/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copyright_TextInputs */

const en_copyright_text = /** @type {(inputs: Copyright_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON`)
};

const ko_copyright_text = /** @type {(inputs: Copyright_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON`)
};

const ja_copyright_text = /** @type {(inputs: Copyright_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON`)
};

/**
* | output |
* | --- |
* | "PureJSON" |
*
* @param {Copyright_TextInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const copyright_text = /** @type {((inputs?: Copyright_TextInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copyright_TextInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_copyright_text(inputs)
	if (locale === "ko") return ko_copyright_text(inputs)
	return ja_copyright_text(inputs)
});